import { Plugin } from "prosemirror-state";
import { Fragment, Slice } from "prosemirror-model";
export function normalizeNestedParagraphs() {
    return new Plugin({
        props: {
            transformPasted(slice) {
                return new Slice(flattenNestedParagraphs(slice.content), slice.openStart, slice.openEnd);
            },
        },
    });
}
/**
 * Iterate through the fragment and find any nested paragraphs.
 * Any other nodes are left alone.
 * */
function flattenNestedParagraphs(fragment) {
    const flattened = [];
    fragment.forEach((child) => {
        if (child.isText) {
            flattened.push(child);
        }
        else if (child.isBlock &&
            child.type === child.type.schema.nodes.paragraph) {
            const content = flattenParagraph(child, child.type);
            flattened.push(child.type.create({}, content));
        }
        else {
            flattened.push(child);
        }
    });
    return Fragment.fromArray(flattened);
}
function flattenParagraph(node, paragraphType) {
    const content = [];
    const flattenedChild = flattenNestedParagraphs(node.content);
    flattenedChild.forEach((grandchild) => {
        content.push(grandchild);
    });
    return Fragment.fromArray(content);
}
